import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=0aaa9f12&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=js&"
export * from "./TextComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=0aaa9f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa9f12",
  null
  
)

export default component.exports